/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-10-23 17:14:55
 **/

import { ChronoUtils } from "@/frameworks/libraries/utilities";
import { Configure } from "@/frameworks/libraries/utilities";
import { Persistence } from "../usePersistStore";
import { useUnityCommand } from "../../unity";

export type StateStates = {
	states: {
		/**
		 * Authorization instance used for controlling access to resources.
		 * This variable holds the authorization logic including roles, permissions, and policies
		 * required to validate whether a user or a system has the requisite access rights.
		 */
		// authorization: Authorization;

		/**
		 * Indicates if the application should automatically detect and apply the user's timezone.
		 *
		 * When set to true, the application will use the client's local timezone settings
		 * to adjust any time-related variables or displays accordingly.
		 * If false, the application will rely on a default timezone setting or user-specified preferences.
		 */
		auto_timezone: boolean;

		/**
		 * Represents the timezone in which the system or application operates.
		 *
		 * This variable stores the timezone as a string, typically in the format
		 * "Area/Location" or a time offset from UTC (e.g., "UTC+2"). This can be
		 * used to format times correctly, perform date calculations, and convert
		 * between different time zones.
		 *
		 * Example values include:
		 * - "America/New_York"
		 * - "Europe/London"
		 * - "UTC+2"
		 *
		 * It is important to set this variable accurately to ensure time-related
		 * functions operate as expected.
		 */
		timezone: string;
		service_mode: "3D_SPACE" | "MY_DESK";
		experimental: {
			// enable_feature_experimental_activity: boolean;
			// enable_feature_experimental_outbound_call: boolean;
			// enable_chat_thread: boolean;
		};
	};
};

export type StateDispatch = {
	// set_authorization_key(key: string): void;
	// set_refresh_key(key: string): void;
	// set_user_id(id: string): void;
	set_service_mode(value: "3D_SPACE" | "MY_DESK"): void;
	get_service_mode(): "3D_SPACE" | "MY_DESK";
	set_auto_timezone(value: boolean): void;
};

export const InitialStateStates: StateStates = {
	states: {
		// authorization: { ak: "", rt: "", id: "" },
		auto_timezone: true,
		timezone: ChronoUtils.guess_timezone,
		service_mode: "3D_SPACE",
		experimental: {}
	}
};

const LOGTAG = "#StateStates#";
export const StateSubscribes = [
	{
		subscribe: (state: Persistence) => state.states.service_mode,
		callback: (state: Persistence["states"]["service_mode"], prevState: Persistence["states"]["service_mode"]) => {
			console.log(LOGTAG, "service_mode", state, prevState);
			Configure.mydeskMode = state === "MY_DESK";
			const { changeCameraStatus, useMydesk } = useUnityCommand();
			changeCameraStatus(state !== "MY_DESK");
			useMydesk({ action: state === "MY_DESK" ? "enter" : "leave" });
		},
		options: {
			fireImmediately: true
		}
	}
];
